<div class="ft-modal" [class]="modalClass()" tabindex="-1" role="dialog">
    <div class="ft-modal-bg">
        <div class="ft-bg-image"></div>
        <div class="ft-bg-matte"></div>
    </div>

    @if (cancelVisible()) {
        <button class="ft-btn-close" (click)="cancel.emit()"></button>
    }

    <div class="ft-modal-container ft-v-align-container" [class]="size()">
        <div class="ft-modal-content ft-v-align-content">
            <!-- (submit) preventDefault = AngularJS's form directive for action-less
                 forms (angular.js handleFormSubmission): v1 ftModal forms NEVER
                 native-submitted. Without it, a consumer projecting exactly ONE text
                 input (e.g. create-contest) lets Enter trigger HTML implicit
                 submission -> a full-page GET navigation (2y verify finding). -->
            <form name="modalForm" novalidate (submit)="$event.preventDefault()">
                @if (headerText() || headerDescription()) {
                    <div class="modal-header">
                        @if (headerText()) {
                            <div class="modal-heading">{{ headerText() }}</div>
                        }
                        @if (headerDescription()) {
                            <div class="modal-summary">{{ headerDescription() }}</div>
                        }
                    </div>
                }
                <div class="modal-body">
                    <ng-content />
                </div>
                @if (footerVisible()) {
                    <div class="modal-footer" [style.text-align]="footerAlign()">
                        <!-- TERMINAL CURATION CUT: projection slot for footer content prepended
                             before the Done/Cancel buttons (v1 ftCurationModal injected the
                             bulk-curation nav into the modal-footer). Additive + select-scoped,
                             so it has no effect on consumers that do not project the slot. -->
                        <ng-content select="[modalFooterContent]" />
                        @if (doneVisible()) {
                            <button
                                type="button"
                                class="btn btn-lg btn-ft-default ft-btn ft-btn-plus-1 ft-btn-default"
                                [disabled]="doneDisabled()"
                                [class.disabled]="doneDisabled()"
                                (click)="done.emit()"
                            >
                                <span>{{ doneText() }}</span>
                            </button>
                        }
                        @if (footerCancelVisible()) {
                            <button
                                type="button"
                                class="ft-btn ft-btn-plus-1 ft-btn-outline-light btn-cancel ft-btn ft-btn-plus-1 ft-btn-outline-light"
                                (click)="cancel.emit()"
                            >
                                {{ footerCancelText() }}
                            </button>
                        }
                    </div>
                }
            </form>
        </div>
    </div>
</div>
